import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import settings from 'settings';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Comments as CommentList } from 'components/Page';
import config from './config';

const { APP_CONFIG } = settings;

const mapStateToProps = state => ({
  inFlight: state.api.commentThemes.inFlight,
  themes: state.api.commentThemes.data.results
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadThemes() {
    const page = 0;
    const pageSize = APP_CONFIG.defaultTablePageSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [
      {
        id: 'model',
        value: ownProps.themeName
      }
    ];

    return dispatch(list(REDUCER_KEY.commentThemes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const Comments = ({
  canAdmin, loadThemes, objectId, permissions
}) => {
  const [themeId, setTheme] = useState(null);
  useEffect(() => {
    loadThemes()
      .then((response) => {
        const { id } = response.results[0];

        setTheme(id);
      });
  }, [objectId]);
  const handlePrepareData = ({ obfuscated_text, hidden }) => ({
    text: obfuscated_text,
    object_theme_id: themeId,
    object_id: objectId,
    hidden
  });
  return (
    <CommentList
      canAdmin={canAdmin}
      reducer={{
        item: REDUCER_KEY.comment,
        list: REDUCER_KEY.comments
      }}
      config={{
        ...config,
        list: {
          ...config.list,
          filters: {
            object_id: [objectId],
            object_theme_id: [themeId]
          }
        },
        detail: {
          ...config.detail,
          parent: {
            object_id: objectId,
            object_theme_id: themeId
          }
        }
      }}
      defaultSize="70%"
      onPrepareData={handlePrepareData}
      permissions={permissions}
    />
  );
};

Comments.propTypes = {
  canAdmin: PropTypes.bool.isRequired,
  objectId: PropTypes.number.isRequired,
  loadThemes: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Comments);
